import React from 'react';
import { Layout, Row, Col } from 'antd';
import StyledAppContentWrapper from './AppContentWrapper.styles';

interface AppContentWrapperProps {
    children: React.ReactNode;
}

const AppContentWrapper: React.FC<AppContentWrapperProps> = ({ children }): React.ReactElement => {
    const { Content } = Layout;
    return (
        <StyledAppContentWrapper>
            <Content className="h-100">
                <Row className="bg-white h-100">
                    <Col span={24} className="p-4">
                        {children}
                    </Col>
                </Row>
            </Content>
        </StyledAppContentWrapper>
    );
};

export default AppContentWrapper;
